import React, { useEffect, useState } from "react";
import styles from "../../assets/containers/book.module.css";
import { getLessons } from '../../service/service';
import ReactGA from 'react-ga';
import BlockCard from "./blockCard";
import LessonCard from "../lessons/lessonCard";
import Banner from "./banner";

const Book = props => {
  const { currentBook, courses, changeBook, currentLanguage, hiddenBanner = false } = props;
  const [groupedLessons, setGroupedLessons] = useState([]);
  const [totalLessonsCount, setTotalLessonsCount] = useState(0);

  const getBatchData = (batchLesson, totalLessons, validGroupIndex) => {
    return {
      id: batchLesson.id,
      // Exibe o nome do batch, caso exista. Caso contrário, exibe "Batch: X"
      name: batchLesson.name && batchLesson.name.trim() !== "" ? batchLesson.name : `Batch: ${validGroupIndex}`,
      totalLessons: totalLessons,
      // Verifica se a propriedade 'batch' existe e se contém pelo menos um item antes de acessar o título e imagem
      title: batchLesson.batch && batchLesson.batch.length > 0 && batchLesson.batch[0].title ? batchLesson.batch[0].title : null,
      image: batchLesson.batch && batchLesson.batch.length > 0 && batchLesson.batch[0].image ? batchLesson.batch[0].image : null
    };
  };

  const loadLessons = () => {
    ReactGA.event({
      category: "Catchup",
      action: "Load Lessons",
      label: `book${currentBook.id}|size100`
    });

    getLessons(currentBook.id, { page_size: 100 })
      .then(lessonData => {
        if (!lessonData.data || lessonData.data.length === 0) {
          console.error(`Nenhuma lição encontrada para este livro`);
          setGroupedLessons([]);
          setTotalLessonsCount(0);
          return;
        }

        // Map to store grouped lessons
        const tempGroupedLessons = new Map();

        // Iterate over lessons to create groups
        lessonData.data.forEach(lesson => {
          const parentId = lesson.parent !== null ? lesson.parent : lesson.id;
          if (!tempGroupedLessons.has(parentId)) {
            tempGroupedLessons.set(parentId, []);
          }
          tempGroupedLessons.get(parentId).push(lesson);
        });

        // Convert the map into an array keeping the original order
        const groupedLessonsArray = [];
        let validGroupIndex = 1; // Índice para manter a ordem dos batches que não têm título definido

        lessonData.data.forEach(lesson => {
          const parentId = lesson.parent !== null ? lesson.parent : lesson.id;
          if (tempGroupedLessons.has(parentId)) {
            const group = tempGroupedLessons.get(parentId);
            if (group.length > 1) {
              const batchLesson = lessonData.data.find((l) => l.id === parentId);
              const batch = getBatchData(batchLesson, group.length, validGroupIndex);

              groupedLessonsArray.push({ batch, group, index: validGroupIndex });
              validGroupIndex++;
            } else {
              groupedLessonsArray.push({ group, index: null });
            }
            tempGroupedLessons.delete(parentId);
          }
        });

        setGroupedLessons(groupedLessonsArray);
        setTotalLessonsCount(lessonData.data.length);
      })
      .catch(err => {
        console.error('Erro ao buscar lições: ', err);
      });
  };

  useEffect(() => {
    loadLessons();
  }, [currentBook]);

  // This is to prevent the information from the last accessed batch to be used
  // when a lesson without batch is completed.
  useEffect(() => {
    localStorage.removeItem("batch");
  }, []);

  return (
    <>
      {!hiddenBanner &&
        <Banner
          currentBook={currentBook}
          courses={courses}
          totalLessonsCount={totalLessonsCount}
          changeBook={changeBook}
          currentLanguage={currentLanguage}
          lessonsAvailable={groupedLessons.length}
        />
      }

      <div className={styles["book-container"]}>
        {
          groupedLessons.map((groupObj, groupIndex) => (
            groupObj.group.length === 1
              ? <LessonCard key={groupIndex} lesson={groupObj.group[0]} groupIndex={groupIndex} />
              : <BlockCard key={groupIndex} lessons={groupObj.group} validIndex={groupObj.index} groupIndex={groupIndex} batch={groupObj.batch} />
          ))
        }
      </div>
    </>
  );
};

export default Book;
